<template>
    <commonbody>
        <div class="corporation-details-header" slot="swiper">
        </div>
        <div class="clearfix common-width-box" id="corporation-details-box" :style="getCommonStyle.style">
            <div class="corporation-details-html-content">
                
                <div class="my-3">
                    葡旅的营业地点葡旅空间：坐落于苏州园区通园路56文创园D栋，室内面积五百多平米， 包括葡萄酒展厅，葡旅文化空间，办公室，恒温仓库。
                </div>
                <div>
                    <div class="row">
                        <div class="col-5">
                            <img src="../../public/images/corp/1.jpg" />
                        </div>
                        <div class="col-5">
                            <img src="../../public/images/corp/2.jpg" />
                        </div>
                    </div>
                    <div class="my-2">葡旅酒款展厅</div>
                </div>
                <div>
                    <div class="row">
                        <div class="col-5">
                            <img src="../../public/images/corp/3.jpg" />
                        </div>
                        <div class="col-5">
                            <img src="../../public/images/corp/4.jpg" />
                        </div>
                    </div>
                    <div class="my-2">葡旅文化空间</div>
                </div>
                <div>
                    <div class="row">
                        <div class="col-5">
                            <img src="../../public/images/corp/5.jpg" />
                        </div>
                        <div class="col-5">
                            <img src="../../public/images/corp/6.jpg" />
                        </div>
                    </div>
                    <div class="my-2">葡旅恒温仓库</div>
                </div>
            </div>
        </div>

    </commonbody>
</template>

<script>
// @ is an alias to /src
import commonbody from '@/components/commonbody.vue';
import * as corporationApi from '@/api/corporation';
import { format, returnContentType } from '@/utils'
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import { mapGetters } from "vuex";

export default {
    name: "CorporationDetails",
    components: {
        commonbody,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            detailsData: {},
            swiperOptions: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true, // 允许点击小圆点跳转
                },
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false // 手动切换之后继续自动轮播
                },
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            },
            imgData: [
                {
                    url: require("../../public/images/corp/8.jpg"),
                    label: "图表 6勃艮第酒庄Domaine Devevey",
                },
                {
                    url: require("../../public/images/corp/9.jpg"),
                    label: "图表 7罗纳河谷Domaine Saladin",
                },
                {
                    url: require("../../public/images/corp/10.jpg"),
                    label: "图表 8德国Weingut Kludnt",
                },
                {
                    url: require("../../public/images/corp/11.jpg"),
                    label: "图表 9Fleury香槟酒庄",
                }
            ]
        };
    },
    computed: {
        ...mapGetters(['getCommonStyle']),
        swiper() {
            return this.$refs?.mySwiper?.$swiper;
        },
    },
    created() {
        // this.paramsUrl();
    },
    methods: {
        /**
         * @desc 获取时间
         */
        parseTime(string) {
            return format(new Date(string))
        },
        /**
         * @desc 检测页面参数是否完整
         */
        paramsUrl() {
            this.selectData();
        },
        /**
         * @desc 通过获取详细数据
         */
        selectData() {
            let params = {
            }
            corporationApi.selectData(params).then(res => {
                FF
                this.detailsData = res.data && res.data[0] || {};
            })
        },
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
.corporation-details-header {
    height: 64px;
    width: 100%;
    // background: url('../../public/images/bg.png') center;
    background-size: cover;

    img {
        width: 100%;
        max-height: 100%;
    }
}

#corporation-details-box {
    width: 80%;
    max-width: 1536px;
    margin: 0 auto;

    .corporation-details-box {
        width: 80%;
        margin: 0 auto;
        padding: 20px;
        text-align: left;

        .corporation-details-content {
            display: flex;
            align-items: center;

            .corporation-details-content-box {
                .product-main-image {
                    position: relative;
                    background: #fff;
                    padding: 20px;
                    width: 140px;
                    height: 140px;
                    top: -70px;
                    left: 50%;
                    transform: translate(-50%);
                    border-radius: 5px;
                    box-shadow: 0.015em 0.015em 1.5em 0em rgb(53, 47, 47);

                    img {
                        width: 100%;
                    }
                }

                h2 {
                    color: #470125;
                    padding-bottom: 20px;
                    // line-height: 40px;
                }

                .purchase {
                    text-align: right;
                }
            }
        }

        .corporation-details-time {
            margin-bottom: 10px;

            span {
                margin: 0 10px;
            }
        }

        .corporation-details-title {
            font-size: 20px;
            text-align: center;
            margin: 35px auto;
        }
    }

    .corporation-details-html-content {
        min-height: 400px;
        padding-bottom: 85px;
        // border-top: 1px solid #BFBFBF;
        overflow: hidden;
        text-align: left;
        // line-height: 30px;

        h2 {
            font-weight: bold;
            font-size: 16px;
        }

        img {
            display: block;
        }

        .indent {
            text-indent: 2em;
            text-align: justify;
        }

        .justify {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .corp-details {
            img {
                width: 100%;
            }

            p {
                margin-bottom: 10px;
            }
        }
    }
}
</style>

<style lang="scss">
#corporation-details-box {
    .corporation-details-html-content {
        img {
            max-width: 100%;
        }
    }
}
</style>